import { Formik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import loginImage1 from "../../../assets/images/loginImage1.png";
import { Image } from "primereact/image";
import logo from "../../../assets/images/logo.svg";
import logo1 from "../../../assets/images/logoLoginScreen.svg";
import { Password } from "primereact/password";
import "./LoginForm.css";
import { loginUser } from "../../../services/auth.service";
import GlobalToast from "../../toast";
import { loginSuccess } from "../../../redux/userSlice";
import useToast from "../../../context/toast.hook";
import { Toast } from "primereact/toast";
const LoginForm = () => {
  const { errorToast, successToast, toastRef } = useToast();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //Yup Form Schema Validitions
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Must be valid Email")
      .required("Email is required!"),
    password: yup.string().required("Password is required!"),
  });

  // Form Intial Values - If its New Form
  const initialValues = {
    email: "",
    password: "",
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    loginUser(values)
      .then((res) => {
        dispatch(loginSuccess(res?.data?.user));
        localStorage.setItem("authToken", res.data.token);
        successToast(res.data.message);
        navigate("/");
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        errorToast(error);
        setLoading(false);
      });
  };

  return (
    <>
      <Toast ref={toastRef} />
      <div
        className="px-5 min-h-screen  flex justify-content-center align-items-center border shadow-6"
        style={{ backgroundColor: "#1C9894" }}
      >
        <div className="border-1 surface-border surface-card  py-7 px-4 md:px-7 z-1 auth-container shadow-8">
          <div className="mainLogoContainer">
            <div className="logoContainer1">
              <Image src={logo} alt="Opta" imageClassName="max-w-10rem" />
            </div>
            <div className="logoContainer2">
              <Image src={logo1} alt="Opta" imageClassName="max-w-10rem" />
            </div>
          </div>
          <div className="mb-4">
            <div className="innerLoginBox">
              Welcome to <strong>OPTA ZEB Dashboard & Data Trust</strong>
            </div>
          </div>
          <Formik
            validationSchema={schema}
            onSubmit={handleSubmit}
            initialValues={initialValues}
            enableReinitialize
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => (
              <form noValidate onSubmit={handleSubmit}>
                <div className="flex flex-column">
                  <div className="field w-full">
                    <label htmlFor="email" className="block text-800">
                      <strong>Email</strong>
                    </label>
                    <InputText
                      id="email"
                      type="email"
                      aria-describedby="email-help"
                      className={`block w-full ${
                        touched.email && errors.email ? "p-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={values.email}
                      placeholder="xyz@opta.com"
                    />
                    {touched.email && errors.email ? (
                      <small id="email-help" className="p-error block">
                        {errors.email}
                      </small>
                    ) : null}
                  </div>

                  <div className="field w-full">
                    <label htmlFor="password" className="block text-800">
                      <strong>Password</strong>
                    </label>
                    <Password
                      id="password"
                      aria-describedby="password-help"
                      feedback={false}
                      className="w-full block pass-wid"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      toggleMask
                      style={{ color: "#1C9894" }}
                    />
                    {touched.password && errors.password ? (
                      <small id="password-help" className="p-error block">
                        {errors.password}
                      </small>
                    ) : null}
                  </div>

                  <Link
                    to="/forgot"
                    style={{ color: "#1C9894" }}
                    className="forgotPassword"
                  >
                    <div className="forgotPassword mt-2">Forgot password?</div>
                  </Link>
                  <Button
                    type="submit"
                    label="Login"
                    className="mt-4"
                    loading={loading}
                    loadingIcon="pi pi-spin pi-spinner"
                    style={{ border: "0" }}
                  />
                </div>
              </form>
            )}
          </Formik>
        </div>
        <div className="loginImage shadow-7">
          <img className="img-wrap" src={loginImage1} alt="Opta" />
        </div>
      </div>
    </>
  );
};

export default LoginForm;
